import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const TUNISIA_TZ = 'Africa/Tunis';

const toDayjs = (value) => {
  if (!value) return null;
  if (dayjs.isDayjs(value)) return value;
  if (value instanceof Date) return dayjs(value);
  if (typeof value === 'string') return dayjs.utc(value).tz(TUNISIA_TZ);
  return dayjs(value);
};

export const dateToNoonUTC = (value) => {
  const d = toDayjs(value);
  if (!d || !d.isValid()) return null;

  return dayjs
    .tz(
      `${d.year()}-${String(d.month() + 1).padStart(2, '0')}-${String(d.date()).padStart(2, '0')} 12:00:00`,
      TUNISIA_TZ
    )
    .utc()
    .toISOString();
};

export const dateTimeToISO = (value, useNoonDefault = true) => {
  const d = toDayjs(value);
  if (!d || !d.isValid()) return null;

  const tunisDate = dayjs.isDayjs(value)
    ? dayjs.tz(d.format('YYYY-MM-DD HH:mm:ss'), TUNISIA_TZ)
    : d.tz
      ? d.tz(TUNISIA_TZ)
      : dayjs.tz(d.format('YYYY-MM-DD HH:mm:ss'), TUNISIA_TZ);

  const isMidnight =
    tunisDate.hour() === 0 &&
    tunisDate.minute() === 0 &&
    tunisDate.second() === 0;

  const finalDate = isMidnight && useNoonDefault
    ? tunisDate.hour(12).minute(0).second(0).millisecond(0)
    : tunisDate;

  return finalDate.utc().toISOString();
};

export const dateTimeToUtc = (value) => {
  const d = toDayjs(value);
  if (!d || !d.isValid()) return null;

  return d.utc().toISOString();
};

export const parseDate = (dateString) => {
  if (!dateString) return null;
  const d = dayjs.utc(dateString).tz(TUNISIA_TZ);
  return d.isValid() ? d : null;
};

export const parseDateOnly = (dateString) => {
  if (!dateString) return null;
  const d = dayjs.utc(dateString).tz(TUNISIA_TZ).startOf('day');
  return d.isValid() ? d : null;
};

export const formatDate = (value, format = 'DD/MM/YYYY') => {
  const d = toDayjs(value);
  return d && d.isValid() ? d.format(format) : '';
};

export const formatDateTime = (value, format = 'DD/MM/YYYY HH:mm') => {
  const d = toDayjs(value);
  return d && d.isValid() ? d.format(format) : '';
};

export const hasTimeSet = (value) => {
  const d = toDayjs(value);
  if (!d || !d.isValid()) return false;
  return d.hour() !== 0 || d.minute() !== 0 || d.second() !== 0;
};

export  const formatDateHour = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const tunisDate = new Date(date.getTime() + 60 * 60 * 1000);

    return tunisDate.toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  };
